var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFreeRoaming = function SvgFreeRoaming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 99,
    height: 92,
    viewBox: "0 0 99 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#76BF43",
    stroke: "#76BF43",
    d: "M48.77 90.9c.36.13.77.13 1.14 0a82.67 82.67 0 0 0 37.12-28.36A52.71 52.71 0 0 0 97.66 32.3c.31-14.24-6.46-24.93-18.6-29.33C69.8-.4 57.3.07 49.35 8.24 41.38.06 28.87-.4 19.6 2.97 7.47 7.37.7 18.06 1 32.3c.66 25.02 20.38 47.64 47.75 58.6ZM20.7 6.05c8.76-3.19 20.67-2.58 27.5 5.78.63.62 1.64.62 2.27 0 6.83-8.36 18.73-8.97 27.5-5.78C88.69 9.95 94.68 19.5 94.4 32.23 93.78 55.8 75 77.07 49.33 87.6 23.68 77.09 4.9 55.8 4.27 32.23 3.98 19.5 9.97 9.94 20.7 6.05Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#76BF43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 24.51c1.48-1.05 9.4-3.9 13-4.51 0 3.63-4.69 10.96-6.06 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 50.58a32.62 32.62 0 0 1 11.31-18.73C39.19 17.85 52.17 18 52.17 18s-1.02 12.01-4.93 16.93m1.2 31.32c3.92.8 9.64 1.47 12.81.77 2.29-.51 6.5-4.16 8.31-6.3 1.2-1.42 1.9-3.56 1.1-4.82-.92-1.47-2.18-2.43-2.22-5.5-.23-13.68 1.6-14.2-9.05-20a49.6 49.6 0 0 0-8.73-3.53M53.43 78c-1.27-3.85-1.35-10.97-1.35-10.97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 16h55v64H18z"
  })))));
};
export default SvgFreeRoaming;